import React from 'react';

import { useIntl } from 'react-intl';
import styled, { useTheme } from 'styled-components';

import ActionButton from 'components/action-button';
import Picture from 'components/picture';
import useMediaQuery from 'hooks/use-media-query';
import HeroLink from 'pages/home/hero-link';
import { useStoreContext } from 'state/store';
import { EventName, emitEvent } from 'utils/event-hub';
import { routes } from 'utils/routing';

import HeroMaskCards from './hero-mask-cards';
import { MainHeroText } from './main-hero-text';
import { HeroContainer, HeroContent } from './styled';
import { IMainHero } from './types';

const StyledPicture = styled(Picture)`
  img {
    object-position: 50% 50%;
  }
`;

const MainHero: React.FC<IMainHero> = ({
  image,
  mobileImage,
  html,
  actionTo,
  heroTextColor,
  heroSuperText,
  heroActionText,
  heroSubText,
  heroMaskCards,
}) => {
  const { isStoreOpenAndAvailable } = useStoreContext();
  const { formatMessage } = useIntl();
  const menuHref = isStoreOpenAndAvailable ? routes.menu : routes.storeLocator;
  const isMobile = useMediaQuery('mobile');
  const theme = useTheme();

  return (
    <>
      <StyledPicture
        image={isMobile && mobileImage ? mobileImage : image}
        alt=""
        onImageLoaded={() => {
          emitEvent(EventName.MAIN_HERO_IMAGE_LOADED);
        }}
      >
        <HeroContent>
          <HeroContainer>
            <MainHeroText
              heroSuperText={heroSuperText}
              defaultTextColor={theme.token('text-default')}
              heroTextColor={heroTextColor}
              html={html}
              heroSubText={heroSubText}
            />
            <HeroLink to={actionTo || menuHref} fullWidth={isMobile}>
              <ActionButton fullWidth={isMobile}>
                {heroActionText || formatMessage({ id: 'viewMenu' })}
              </ActionButton>
            </HeroLink>
          </HeroContainer>
        </HeroContent>
      </StyledPicture>
      {heroMaskCards && heroMaskCards.length > 0 && <HeroMaskCards cards={heroMaskCards} />}
    </>
  );
};

export default MainHero;
